// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"a633be42","193":"6b86b8bf","213":"4122b0ec","239":"e798e77b","455":"d2479da4"}[chunkId] + ".chunk.js";
};